import { HiPencil, HiX } from "react-icons/hi";
import { useTranslation } from "@repo/core";

const NOTE_MAX_LENGTH = 5000;

const NoteModal = ({
  isSaving,
  note,
  setNote,
  handleNoteCancel,
  handleNoteSave,
}: {
  isSaving: boolean;
  note: string;
  setNote: (note: string) => void;
  handleNoteCancel: () => void;
  handleNoteSave: () => void;
}) => {
  const { tStrategy, tCommon } = useTranslation();

  return (
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-50"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          handleNoteCancel();
        }
      }}
    >
      <div className="bg-white rounded-lg p-6 max-w-2xl w-full mx-4">
        <h3 className="text-lg font-medium text-gray-900 mb-4">
          {tStrategy("note.stripTitle")}
        </h3>
        <div className="mb-2">
          <textarea
            value={note}
            onChange={(e) => setNote(e.target.value)}
            maxLength={NOTE_MAX_LENGTH}
            rows={12}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-y"
            autoFocus
          />
        </div>
        <div className="mb-6 text-right text-xs text-gray-500">
          {note.length}/{NOTE_MAX_LENGTH}
        </div>
        <div className="flex gap-3 justify-end">
          <button
            onClick={handleNoteCancel}
            disabled={isSaving}
            className="cursor-pointer flex items-center gap-2 px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <HiX size={16} />
            {tCommon("cancel")}
          </button>
          <button
            onClick={handleNoteSave}
            disabled={isSaving}
            className="cursor-pointer flex items-center gap-2 px-4 py-2 bg-blue-600 text-white hover:bg-blue-700 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <HiPencil size={16} />
            {isSaving ? tStrategy("editModal.saving") : tCommon("save")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NoteModal;
